// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__2eeTu","errors":"Errors_errors__3fakI"};